module.exports = ".registerpage {\n  padding-top: 100px; }\n\n.navbar {\n  border-radius: 0px;\n  color: white;\n  padding-left: 5px;\n  background-color: #336699;\n  min-height: 40px;\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/registration.component.scss
// module id = ./src/app/registration/registration.component.scss
// module chunks = main